import React from "react";
import {
  Grid,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

const todayDate = new Date();
const Options = [
  { name: Ext.Date.format(todayDate, "M j, Y"), val: "M j, Y" },
  { name: Ext.Date.format(todayDate, "n/j/Y"), val: "n/j/Y" },
  { name: Ext.Date.format(todayDate, "Y/n/j"), val: "Y/n/j" },
  { name: Ext.Date.format(todayDate, "D, M j"), val: "D, M j" },
];

function DateColumnConfig({
  values,
  handleChange,
  setFieldValue,
  valuesPath = "",
  isOnlyFormattingConfig,
}) {
  React.useEffect(() => {
    if (values.options.format) {
      return;
    }
    setFieldValue(`${valuesPath}options.format`, "M j, Y");
  }, [setFieldValue, values.options.format, valuesPath]);

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Select
          name={`${valuesPath}options.format`}
          value={values.options.format ?? ""}
          onChange={handleChange}
          variant="outlined"
          style={{ width: 200 }}
        >
          {Options.map((option) => (
            <MenuItem value={option.val}>{option.name}</MenuItem>
          ))}
        </Select>
      </Grid>
      {!isOnlyFormattingConfig && (
        <>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  color="primary"
                  name={`${valuesPath}options.default_current_time`}
                  checked={values.options.default_current_time ?? ""}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setFieldValue(
                        `${valuesPath}options.allow_free_text`,
                        true
                      );
                    }
                    handleChange(e);
                  }}
                />
              }
              label={"Default as Current Date"}
            />
          </Grid>
          {values.options.default_current_time && (
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    color="primary"
                    name={`${valuesPath}options.allow_free_text`}
                    checked={values.options.allow_free_text || false}
                    onChange={handleChange}
                  />
                }
                label={"Allow user to change Date"}
              />
            </Grid>
          )}
        </>
      )}
    </React.Fragment>
  );
}

export default DateColumnConfig;
